import { shallowRef } from 'vue'
import { defineStore } from 'pinia'

export const useAppStore = defineStore('admin-app', {
  state: () => ({ 
    sidebarCollapsed: false, 
    globalLoading: false 
  }),
  actions: {
    toggleSidebar() { this.sidebarCollapsed = !this.sidebarCollapsed },
    setGlobalLoading(value: boolean) { this.globalLoading = value },
  },
})
